import moment from "moment-business-days";
import tz from "moment-timezone";
tz.tz.setDefault("America/Sao_Paulo");

var idependencyDay = "09-07";

moment.updateLocale("pt-br", {
  holidays: [idependencyDay],
  holidayFormat: "MM-DD"
});

export default moment;



// WEBPACK FOOTER //
// ./src/utils/moment.js